import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import classnames from 'classnames';
import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { R as RadioSkeleton, s as styles } from './RadioSkeleton-CMmjaC_K.js';
import { RadioCircleSize24 } from '@hh.ru/magritte-ui-icon/variants/private';
import { enrichWithSkeleton } from '@hh.ru/magritte-ui-skeleton';
import '@hh.ru/magritte-common-use-loading-state';

const RadioComponent = ({ checked, disabled, invalid, onChange, readOnly, 'aria-label': ariaLabel, 'data-qa': dataQaInput, dataQaContainer = 'radio-container', dataQaRadio = 'radio', ...props }) => {
    const forceDisabled = useDisabled();
    return (jsxs("span", { className: styles.radioContainer, "data-qa": dataQaContainer, children: [jsx("input", { ...props, checked: checked, "data-qa": dataQaInput, 
                // Checkable Card вызывает event.preventDefault(),
                // из-за чего браузер не перерисовывает радиокнопку при изменении пропа checked,
                // поэтому в controlled радиокнопках полагаемся на CSS-класс, а не на селектор :checked
                className: classnames(styles.radioInput, {
                    [styles.radioInputChecked]: checked,
                    // нужно отличать false от undefined, потому что в случае uncontrolled радиокнопки
                    // checked равен undefined и значение задается через проп defaultChecked
                    [styles.radioInputUnchecked]: Object.is(checked, false),
                }), type: "radio", readOnly: readOnly, "aria-label": ariaLabel, disabled: forceDisabled || !!disabled, onChange: onChange }), jsx("span", { className: classnames(styles.radio, {
                    [styles.invalid]: invalid,
                }), "data-qa": dataQaRadio }), jsx("span", { className: styles.iconWrapper, children: jsx(RadioCircleSize24, {}) })] }));
};
RadioComponent.isRadio = true;
const Radio = enrichWithSkeleton(RadioComponent, RadioSkeleton);

export { Radio };
//# sourceMappingURL=Radio.js.map
